import { Directive, ElementRef, HostListener, Input } from '@angular/core';
@Directive({
  selector: '[select]'
})
export class SelectDirective {
  constructor(private el: ElementRef) { }

  @HostListener('change')
  onChange() {
    this.highlight('yellow');
  }
  @HostListener('click')
  onClick() {
    this.highlight(null);
  }
  private highlight(color: string) {
    this.el.nativeElement.style.backgroundColor = color;
  }
}